import axios from 'axios';

// arquivo que tem as configurações globais
// to starterpack e das bibliotecas

axios.defaults.baseURL = process.env.API_ENDPOINT;

export const Global = {
  format: {
    displayDate: 'DD/MM/YYYY',
    displayDateTime: 'DD/MM/YYYY HH:mm',
    parseDate: 'YYYY-MM-DD',
    parseDateTime: 'YYYY-MM-DD HH:mm Z',
  },
  info: {
    version: '1.9.0',
    name: 'Ciclos',
  },
};



// WEBPACK FOOTER //
// ./src/Config.js